import { render, staticRenderFns } from "./DetectDevices.vue?vue&type=template&id=65462980&scoped=true"
import script from "./DetectDevices.vue?vue&type=script&lang=js"
export * from "./DetectDevices.vue?vue&type=script&lang=js"
import style0 from "./DetectDevices.vue?vue&type=style&index=0&id=65462980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65462980",
  null
  
)

export default component.exports